import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, Grid, TS_AppTools } from '@nu-art/thunderstorm-frontend/index';
import './ATS_Icons.scss';
import '../../../../styles/component-styles/icon.scss';
import { ICONS } from '../../../../icons/index.js';
const advisorIcons = [
    ICONS.advisor_avn_labs.component,
    ICONS.advisor_avn_add.component,
    ICONS.advisor_avn_admit.component,
    ICONS.advisor_avn_discharge.component,
    ICONS.advisor_avn_consultation.component,
    ICONS.advisor_avn_close.component,
    ICONS.advisor_avn_addNote.component,
    ICONS.advisor_v5_expand.component,
    ICONS.advisor_v5_search.component,
    ICONS.advisor_avn_gear.component,
];
export class ATS_Icons extends ComponentSync {
    static Screen = {
        name: 'Icons',
        key: 'icons',
        group: 'Components',
        renderer: this,
    };
    renderRow = (IconRenderer, index) => {
        return _jsxs(React.Fragment, { children: [_jsx(IconRenderer, {}), _jsx(IconRenderer, { className: 'in-use' }), _jsx(IconRenderer, { className: 'disabled' })] }, index);
    };
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('Icons '), _jsxs(Grid, { className: 'ats-icons', children: [_jsx("div", { children: "Regular (Hover on icon to see hover effect)" }), _jsx("div", { children: "In Use" }), _jsx("div", { children: "Disabled" }), advisorIcons.map((icon, index) => this.renderRow(icon, index))] })] });
    }
}
//# sourceMappingURL=ATS_Icons.js.map